import React from 'react';
import styled from 'styled-components';
import Button from '@components/dataEntry/button/Button';
import { Link } from 'react-router-dom';

const Container = styled.div`
  width: 100vw;
  height: 100dvh;
  display: flex;
  justify-content: center;
  padding-top: 120px;

  @media (max-width: 480px) {
    padding-top: 0px;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  max-width: 360px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

function NoExistPage() {
  return (
    <Container>
      <Wrapper>
        <h6>
          <strong>존재하지 않는 게시글입니다.</strong>
        </h6>
        <Link to="/">
          <Button>홈으로 가기</Button>
        </Link>
      </Wrapper>
    </Container>
  );
}

export default NoExistPage;
